import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { BsModalRef } from 'ngx-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { ComboProveedor } from '../../../core/model/combos';
import { SituacionSolicitud } from '../../../core/model/detalle-solicitud';
import { PopulateService } from '../../../core/services/populate.service';

@Component({
  selector: 'app-change-proveedor-solicitud',
  templateUrl: './change-proveedor-solicitud.component.html',
  styleUrls: ['./change-proveedor-solicitud.component.css']
})
export class ChangeProveedorSolicitudComponent implements OnInit {


  header = '';
  message = '';

  idCliente: number;
  idProveedorInicial: number;
  idProveedorFinal: number;
  observacionesCambio = '';
  showModal = true;

  loading = false;

  onClose = new Subject();
  onSaveCambios = new Subject<any>();

  cbProveedor: ComboProveedor[] = [];
  public subscription_proveedores;

  allSituaciones: SituacionSolicitud[] = [];
  cbSituacion: SituacionSolicitud[] = [];
  situacionFinalTraza: string;


  filterForm = new FormGroup({
    idProveedorFinal: new FormControl(0),
    observacionesCambio: new FormControl(1),
    situacionFinalTraza: new FormControl(2)
  });

  constructor(
    private _bsModalRef: BsModalRef,
    private toastr: ToastrService,
    private populateService: PopulateService,
    private translateService: TranslateService,
  ) { }

  public ngOnInit(): void {
    this.onClose = new Subject();

  }

  showConfirmationModal(header, message, idCliente, idProveedor, allSituaciones) {
    this.header = header;
    this.message = message;
    this.idProveedorInicial = idProveedor;
    this.idCliente = idCliente;
    this.getProveedor(this.idCliente);
    this.allSituaciones = allSituaciones;
    this.cbSituacion = this.allSituaciones.filter(sit => sit.ESTADO.NOMBRE == 'Finalizada');
    this.situacionFinalTraza == null;
  }

  ngOnDestroy() {

    if (this.subscription_proveedores != null) { this.subscription_proveedores.unsubscribe(); }
    this.populateService = null;
  }

  getProveedor(idcliente?: number) {
    this.subscription_proveedores = this.populateService.getComboProveedores(idcliente)
      .subscribe(
        (p) => {
          this.cbProveedor = p.sort(function (a, b) {
            if (a.NOMBRE < b.NOMBRE) { return -1; }
            if (a.NOMBRE > b.NOMBRE) { return 1; }
            return 0;
          });
        },
        errorCode => {
          if (errorCode.status == 403) {
            this.toastr.warning('No se cumplen los requisitos para poder filtrar por el campo Proveedores', 'SIN PERMISO');
          }
          else {
            this.toastr.warning('Error cargando el filtro de Proveedores', 'PROVEEDORES');
          }
        });
  }


  public onCancel(): void {
    this.showModal = false;
    this.onClose.next(false);
    this._bsModalRef.hide();
  }

  public onConfirm(): void {
    this.showModal = false;
    this.onClose.next(true);
    this._bsModalRef.hide();
  }

  save() {

    if (this.observacionesCambio === null || this.observacionesCambio === "") {
      this.toastr.warning('Es obligario completar el campo OBSERVACIONES para poder cambiar de proveedor.', 'FALTAN DATOS');
    }
    else if (this.situacionFinalTraza === undefined || this.situacionFinalTraza === null || this.situacionFinalTraza === "") {
      this.toastr.warning('Es obligario completar el campo SITUACION para poder cambiar de proveedor.', 'FALTAN DATOS');
    }
    else if (this.idProveedorFinal === undefined || this.idProveedorFinal === null) {
      this.toastr.warning('Es obligario completar el campo PROVEEDOR para poder cambiar de proveedor.', 'FALTAN DATOS');
    }
    else {
      this.loading = true;
      this.onSaveCambios.next({ idProveedorFinal: this.idProveedorFinal, observacionesCambio: this.observacionesCambio, situacionFinalTraza: this.situacionFinalTraza });
      this.onConfirm();
    }
  }


}
